<script lang="ts" setup>
const props = defineProps<{
  params: Partial<FilterInput.Record>
}>()
const params = toRef(props, 'params')

const link = useFilterLink(params)
</script>

<template>
  <RouterLink class="filter-link" :to="link">
    <slot />
    <i class="pi pi-search" />
  </RouterLink>
</template>

<style lang="scss" scoped>
.filter-link {
  color: var(--text-primary);
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 0.2em;

  .pi {
    margin-left: 0.35em;
  }
}
</style>
